import apiClient from '@/services/axios'

export async function put(venueSetup, products) {

  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/products/' + venueSetup.id, products);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to put products.')
}
